import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CompanyResponse} from '../../../../@shared/models/response.module';
import {CompanyService} from '../../../../@shared/services/company.service';
import {_COR_COY_8} from '../../../../@shared/models/input.module';

@Component({
  selector: 'app-update-company-image',
  standalone: false,
  templateUrl: './update-company-image.html',
  styleUrl: './update-company-image.css'
})
export class UpdateCompanyImage {
  @Input() company: CompanyResponse
  @Input() imageType: 'header' | 'logo' = 'logo';

  selectedFile: File | null = null;
  uploading: boolean = false;

  constructor(private companyService: CompanyService,
              private modal: NgbActiveModal) {
  }

  get title(): string {
    return this.imageType === 'header' ? 'Update Header Image' : 'Update Company Logo';
  }

  get currentImageUrl(): string | null {
    return this.imageType === 'header' ? (this.company.header_image_url ?? null) : (this.company.company_logo_url ?? null);
  }

  get description(): string {
    return this.imageType === 'header'
      ? 'Upload a new header image for your company (recommended size: 1920x300)'
      : 'Upload a new logo for your company (recommended size: 400x400)';
  }

  onSave() {
    if (!this.selectedFile) {
      return;
    }

    this.uploading = true;
    const payload: _COR_COY_8 = {
      image_type: this.imageType,
      image: this.selectedFile
    };

    this.companyService.editCompanyFiles(payload).subscribe({
      next: () => {
        this.uploading = false;
        this.modal.close(true);
      },
      error: () => {
        this.uploading = false;
      }
    });
  }

  close() {
    this.modal.close();
  }
}
